<template>
  <el-scrollbar style="height:100%">
    <el-row class="filterTree" v-if="supportFilter">
      <el-col :span="12" :offset="1">
        <el-input placeholder="输入名称过滤" v-model="filterText"> </el-input>
      </el-col>
    </el-row>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      :support-filter="supportFilter"
      :highlight-current="highlightCurrent"
      :default-expand-all="defaultExpandAll"
      :filter-node-method="filterNode"
      :default-expanded-keys="['-1', '1']"
      :default-checked-keys="defaultCheckedKeys"
      :node-key="nodeKey"
      :check-strictly="checkStrictly"
      :show-checkbox="showCheckbox"
      :render-content="renderContent"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      @check="checkNode"
      @refresh="loadData"
      ref="ecoMenuTree"
    >
      <!-- 作用域插槽：插槽prop -->
      <slot slot-scope="{ node, data }" :node="node" :data="data"></slot>
    </el-tree>
  </el-scrollbar>
</template>

<script>
import portalApi from "@/api/portal.js";

export default {
  name: "fe-menu-tree",
  props: {
    supportFilter: {
      type: Boolean,
      default: false
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    },
    defaultCheckedKeys: {
      type: Array
    },
    nodeKey: {
      type: String,
      default: "alias"
    },
    // 是否展示语言包菜单
    i18nAPi: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.ecoMenuTree.filter(val);
    }
  },
  data() {
    return {
      treeFlat: [],
      treeData: [],
      filterText: "",
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  methods: {
    checkNode(node, section) {
      if (
        section &&
        section.checkedKeys &&
        section.checkedKeys.indexOf(node.alias) > -1
      ) {
        if (node.children.length > 0) {
          node.children.forEach(a => {
            this.setChecked(a);
          });
        }
        if (node.parentId) {
          this.setParent(node.parentId);
        }
      } else {
        if (node.children.length > 0) {
          node.children.forEach(a => {
            // if (a.menuType != 1){
            this.setUnChecked(a);

            // }
          });
        }
        // if (node.parentId && node.menuType != 1) {
        //   const selectTree = this.$refs.ecoMenuTree
        //     .getCheckedNodes()
        //     .map(obj => {
        //       return obj.alias;
        //     });
        //   this.checkParent(node.parentId, selectTree);
        // }
      }
    },
    checkParent(id, section) {
      const parent = this.treeFlat.find(m => m.id == id);
      let childrenCheck = 0;
      if (parent.children && parent.children.length > 0) {
        parent.children.forEach(v => {
          if (section && section.indexOf(v.alias) > -1) {
            childrenCheck++;
          }
        });
      }
      if (childrenCheck == 0) {
        this.$refs.ecoMenuTree.setChecked(parent.alias, false, false);
      }
      if (parent.parentId) {
        const selectTree = this.$refs.ecoMenuTree.getCheckedNodes().map(obj => {
          return obj.alias;
        });

        this.checkParent(parent.parentId, selectTree);
      }
    },
    setParent(id) {
      const parent = this.treeFlat.find(m => m.id == id);
      this.$refs.ecoMenuTree.setChecked(parent.alias, true, false);
      if (parent.parentId) {
        this.setParent(parent.parentId);
      }
    },
    setChecked(item) {
      if (item.alias) {
        this.$refs.ecoMenuTree.setChecked(item.alias, true, false);
        if (item.children && item.children.length > 0) {
          item.children.forEach(a => {
            this.setChecked(a);
          });
        }
      }
    },
    setUnChecked(item) {
      if (item.alias) {
        this.$refs.ecoMenuTree.setChecked(item.alias, false, false);
        if (item.children && item.children.length > 0) {
          item.children.forEach(a => {
            this.setUnChecked(a);
          });
        }
      }
    },
    flat(arr) {
      return [].concat(
        ...arr.map(item => [].concat(item, ...this.flat(item.children)))
      );
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(node) {
      this.$emit("node-click", node);
    },
    /**
     * 节点更新 判断是否是添加 删除 保存直接更新节点信息
     * @param dataKeyList parentId数组
     * @param data 修改的新数据
     */
    updateNode(dataKeyList, data) {
      this.$refs.ecoMenuTree.updateKeyChildren(dataKeyList, data);
    },
    // 加载全部数据
    loadData(cb) {
      if (this.i18nAPi) {
        portalApi
          .getMenuTreeByI18n()
          .then(data => {
            this.treeData = data;
            this.treeFlat = this.flat(data);
          })
          .finally(() => {
            cb && cb();
          });
      } else {
        portalApi
          .getMenuTree()
          .then(data => {
            this.treeData = data;
            this.treeFlat = this.flat(data);
          })
          .finally(() => {
            cb && cb();
          });
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style lang="scss" scoped>
.filterTree {
  padding: 10px 0;
}
>>> .el-tree .el-tree__empty-block {
  margin: 20px 20px;
}

>>> .el-tree {
  width: 100%;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
